/**
 * 充值记录
 * Create by liaokai on 2020-04-30 12:10:51
 */
import * as React from 'react';
import {Component} from "react";
import {Button} from "antd";
import {PrepaidTable} from "./prepaid-table/prepaid-table";
import {journalAccountRecord} from "../../../../../common/apis/apis/journalAccountRecord";
import {apis} from "../../../../../common/apis/apis";

interface IProps{

}

interface IState{

}

export class PrepaidRecord extends Component<IProps,IState>{
    readonly state : IState = {

    };
    render() {
        let {} = this.props;
        let {} = this.state;
        return (
            <div>
                {/*<div style={{display: "flex", justifyContent : "flex-end",margin: "0px 0px 15px"}}>*/}
                {/*    <Button type={"link"} style={{paddingRight: 0}} onClick={()=>{*/}
                {/*        apis.journalAccountRecord({}).then(res => {*/}
                {/*            window.location.href = res.excelDownloadUrl*/}
                {/*        })*/}
                {/*    }}>导出记录</Button>*/}
                {/*</div>*/}
                <div>
                    <PrepaidTable/>
                </div>
            </div>
        );
    }
}
